import { blogArticles } from '@/mocks/blog';
import { Link } from 'react-router-dom';

export default function BlogSection() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-12 lg:px-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-14 gap-6">
          <div>
            <p className="text-foreground-400 text-sm font-medium tracking-wide uppercase mb-2">Latest Guides</p>
            <h2 className="text-foreground-950 text-4xl md:text-5xl font-bold font-heading">Buying Tips &amp; Reviews</h2>
          </div>
          <p className="text-foreground-600 text-base leading-relaxed max-w-[500px]">
            Stay informed with our latest Kakobuy Spreadsheet guides, tutorials, and comprehensive reviews. Expert advice updated weekly to help you shop smarter.
          </p>
        </div>

        {/* Blog Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {blogArticles.map((article) => {
            const cardContent = (
              <>
                <div className="relative w-full h-48 md:h-56 overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5 md:p-6">
                  <span className="inline-block px-3 py-1 bg-accent-100 text-foreground-950 text-xs font-semibold rounded-md mb-3 whitespace-nowrap">
                    {article.tag}
                  </span>
                  <h3 className="text-foreground-950 text-base md:text-lg font-bold font-heading leading-snug mb-2">
                    {article.title}
                  </h3>
                  <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2">
                    {article.excerpt}
                  </p>
                  <span className="inline-flex items-center gap-1 mt-4 text-sm font-semibold text-foreground-800 group-hover:text-foreground-950 transition-colors whitespace-nowrap">
                    Read More
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-line"></i>
                    </span>
                  </span>
                </div>
              </>
            );

            if (article.hasPage) {
              return (
                <Link
                  key={article.id}
                  to={`/${article.slug}`}
                  className="group block bg-background-100 rounded-2xl overflow-hidden hover:bg-background-200 transition-all duration-300 cursor-pointer"
                >
                  {cardContent}
                </Link>
              );
            }

            return (
              <a
                key={article.id}
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="group block bg-background-100 rounded-2xl overflow-hidden hover:bg-background-200 transition-all duration-300 cursor-pointer"
              >
                {cardContent}
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}